export default __webpack_public_path__ + "static/media/Group 3199.ea567602.svg";